<template>
    <div class="wishlist">
        <button class="btn btn-danger"
                @click.prevent="remove"
        >
            {{ btnText }}
        </button>

<!--        <InfoModal-->
<!--            v-if="withModal"-->
<!--            :open="showModal"-->
<!--            title="Produkt bol pridaný medzi obľúbené."-->
<!--            @closed="showModal = false"-->
<!--        />-->
    </div>
</template>

<script>
import {inject, reactive, toRefs} from 'vue'
import axios from 'axios'

// import InfoModal from '../modals/InfoModal'

export default {

    props: [
        'productId',
        'btnText',
        'withModal'
    ],

    components: {
        // InfoModal
    },

    setup(props, {emit}) {

        const state = reactive({
            showModal: false
        })

        const emitter = inject('emitter')

    function remove() {
      axios
        .get(`/produkt/oblubene-produkty/${props.productId}/odstranit`)
        .then((response) => {
          console.log(response);
          flash(response.data.message, response.data.type);
          if (response.status === 200) {
            emitter.emit("on-product-deleted", props.productId);
            emitter.emit("product-wishlist-update", response.data.message);
            //update header heart icon count
            updateFavouritesCount(response.data.count);
          }
        })
        .catch((error) => console.log(error));
    }

        function updateFavouritesCount(count) {
            const icon = document.getElementById("wishlistItemCounter");

            if (count == 0 || count == undefined || count == null || count == "")
                count = 0;
            icon.innerHTML = count;
            /*if (count != "" || count != "0" || count != 0 || count != undefined || count != null && icon.classList.contains("d-none")) {
                icon.classList.remove("d-none");
            } else if (count == "" || count == "0" || count == 0 || count == undefined || count == null && !icon.classList.contains("d-none")) {
                icon.classList.add("d-none");
            }*/
            emitter.emit('on-wishlist-count-change', count)
        }

        return {
            ...toRefs(state),
            remove
        }
    }
}
</script>
